import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiAws,
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";
import { FaAws } from "react-icons/fa";

function Techstack() {
  const iconStyle = {
    fontSize: "4rem",
    color: "#c084f5", // Purple color to match your theme
    padding: "10px",
    transition: "all 0.3s ease",
    cursor: "pointer"
  };

  const hoverStyle = {
    transform: "scale(1.1)",
    color: "#a855f7" // Slightly different purple on hover
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <DiAws 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaAws 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSolidity 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextdotjs 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiGit 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiRedis 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJava 
          style={iconStyle}
          onMouseEnter={(e) => Object.assign(e.target.style, hoverStyle)}
          onMouseLeave={(e) => Object.assign(e.target.style, iconStyle)}
        />
      </Col>
    </Row>
  );
}

export default Techstack;